module.exports = __webpack_public_path__ + "img/alfred_thumb.f8429120.jpg";